import styled from 'styled-components';

const FormInputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.S12};
`;

export { FormInputsContainer };
